import util from '@/tools/commonUtil'
export default {
  id: '',
  groupId: '',
  belongId: '',
  isRequired: '1',
  orderById: 100,
  elementType: 'MultiNumberBox',
  elementDesc: '多行数字',
  type: 'multinumberbox',
  // 是否可配置
  config: true,
  title: '多行数字',
  placeholder: '多行数字',
  itemName: 'optionList',
  imgUrl: '',
  imgName: '',
  optionList: [],
  vertical: true,
  value: [],
  ruleError: '该字段不能为空',
  saveCb (data) {
    this.optionList = util.genRetList.call(this, data.optionList, 'option', {value: ''})
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      orderyNum: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/MultiNumberBox/config.js